import React from 'react'
import { Route, Switch } from 'react-router'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import clsx from 'clsx'
import Dropdown from 'react-dropdown'

import Stats from './Stats'
import PaymentCharts from './PaymentCharts'
import AvailabilityRequestMatches from './AvailabilityRequestMatches'
import AvailabilityRequestNotifications from './AvailabilityRequestNotifications'
import AdminUsersIndex from './Users/Index'
import AdminUsersShow from './Users/Show'
import AvailabilityNotifications from './AvailabilityNotifications/Index'
import Facilities from './Facilities/Index'
import PaymentsSummary from './Payments/Summary'
import Payments from './Payments/Index'

if (process.env.NODE_ENV === 'production') {
  require('../../tailwind.generated.css')
} else {
  require('../../tailwind.all.css')
}

export const AdminHeader = ({ className, children }) => (
  <h1 className={clsx(className, 'text-2xl font-semibold text-gray-600 mb-12')}>{children}</h1>
)

const Nav = [
  {
    label: 'Users',
    value: '/users'
  },
  {
    label: 'Facilities',
    value: '/facilities'
  },
  {
    label: 'Stats',
    value: '/stats'
  },
  {
    label: 'Payments',
    items: [
      { label: 'Recent', value: '/payments/recent' },
      { label: 'Chart', value: '/payments' },
      { label: 'Month Summary', value: '/payments/summary' }
    ]
  },
  {
    label: 'Matches / Notifications',
    items: [
      {
        label: 'Max Matches',
        value: '/availability_requests/matches'
      },
      {
        label: 'Max Notifications',
        value: '/availability_requests/Notifications'
      },
      {
        label: 'Notifications',
        value: '/availability_notifications'
      }
    ]
  }
]

export const Admin = () => {
  const dispatch = useDispatch()
  const token = useSelector(store => store.session.token)

  const NavItem = ({ nav }) => {
    return (
      <div className="flex-initial">
        <Link to={`/admin${nav.value}`}>
          <span className="font-semibold text-base block mt-1">{nav.label}</span>
        </Link>
      </div>
    )
  }

  const NavGo = item => dispatch(push(`/admin${item.value}`))

  const NavDropdown = ({ nav }) => {
    return (
      <Dropdown
        options={nav.items}
        baseClassName="wl-select"
        className="relative"
        controlClassName="relative overflow-hidden flex justify-between items-center"
        menuClassName="mt-2 absolute overflow-y-auto m-h-80 z-50 bg-white w-64 border border-t-0 border-green-500 rounded-md rounded-t-none text-xl font-semibold"
        onChange={NavGo}
        placeholder={nav.label}
        placeholderClassName="font-semibold text-base block mt-1 cursor-pointer"
      />
    )
  }
  return (
    <div className="sans bg-white text-gray-700 min-h-screen">
      <div className="flex items-center justify-between h-16 bg-green-500">
        <div className="flex items-center">
          <div className="flex-shrink-0 inset-x-0 z-100 items-center pl-6">
            <h1 className="font-bold text-gray-100 text-xl inline">
              <Link to="/admin/">Wandering Labs :: Reserve :: Admin</Link>
            </h1>
          </div>
        </div>
      </div>
      <div className="flex space-x-4 bg-green-300 pl-6 pb-2">
        {Nav.map(nav => (
          <React.Fragment key={nav.label}>
            {nav.items && <NavDropdown nav={nav} />}
            {!nav.items && <NavItem nav={nav} />}
          </React.Fragment>
        ))}
      </div>
      <div className="container min-h-screen">
        <div className={`my-1 pt-2 pb-2 px-6 flex-1`}>
          <Switch>
            <Route exact path="/admin/facilities" component={Facilities} />

            <Route exact path="/admin/stats" component={Stats} />
            <Route exact path="/admin/payments/recent" component={Payments} />

            <Route exact path="/admin/payments" component={PaymentCharts} />
            <Route exact path="/admin/payments/summary" component={PaymentsSummary} />

            <Route exact path="/admin/availability_requests/matches" component={AvailabilityRequestMatches} />
            <Route
              exact
              path="/admin/availability_requests/notifications"
              component={AvailabilityRequestNotifications}
            />
            <Route exact path="/admin/users/:id" component={AdminUsersShow} />
            <Route exact path="/admin/users" component={AdminUsersIndex} />
            <Route exact path="/admin/availability_notifications" component={AvailabilityNotifications} />
          </Switch>
        </div>
      </div>
    </div>
  )
}

export default Admin
